<template>
  <div class="w-full">
    <vx-card>
      <div class="vx-card__title mb-10">
        <h1 class="mb-6">Здравствуйте, {{ authUser.name }}</h1>
        <p v-if="isEmailVerified" class="text-success">Ваша почта успешно подтверждена</p>
        <p v-else class="text-danger">Ваша почта не подтверждена</p>
      </div>
      <vs-button v-if="!isEmailVerified" @click="handleClickResend" :disabled="alreadySent">
        <span v-if="alreadySent">Ссылка отправлена на Вашу почту</span>
        <span v-else>Выслать ссылку повторно</span>
      </vs-button>
    </vx-card>
  </div>
</template>

<script>
import Auth from '../api/http/models/auth/Auth'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      alreadySent: false
    }
  },

  created () {
    // Редирект на страницу клиентов
    this.$router.push({name: 'clients'})
  },

  computed: mapGetters(['isEmailVerified', 'authUser']),

  methods: {
    async handleClickResend () {
      const response = await Auth.verifyResend()
      this.alreadySent = true

      if (response.status === 'success') {
        this.$vs.notify({
          color: 'success',
          title: 'На вашу почты было отправлено сообщение',
          text: ''
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка',
          text: ''
        })
      }
    }
  }
}
</script>
